import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sprout } from "lucide-react";

export default function MandiStrip() {
  const [rates, setRates] = useState([]);
  useEffect(() => { api.get("/mandi").then((r) => setRates(r.data)).catch(() => {}); }, []);
  if (rates.length === 0) return null;
  return (
    <div className="bg-emerald-700 text-white overflow-hidden" data-testid="mandi-strip">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center gap-4">
        <span className="shrink-0 bg-white text-emerald-700 text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded flex items-center gap-1">
          <Sprout className="w-3 h-3"/>मंडी भाव
        </span>
        <div className="overflow-hidden flex-1">
          <div className="marquee-track text-sm">
            {[...rates, ...rates].map((r, i) => (
              <span key={`${r.id}-${i}`} className="mr-8">
                <span className="font-bold">{r.crop}</span> ₹{r.price} <span className="opacity-70 text-xs">({r.unit} · {r.market})</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
